// ** Redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getLanding = createAsyncThunk(
	"landing/getLanding",
	createApiCall(async ({ language }, client) => {
		client.modifyLanguageHeader(language);
		const response = await client.post(
			"/merge/bulk/unauthorized",
			JSON.stringify([
				{
					key: "images",
					url: `datezone/main-photo`,
					args: {
						limit: 12,
						type: "square",
					},
					version: "1.1",
				},
				{
					key: "seo",
					url: `datezone/main-seo-location`,
					args: {
						limit: 12,
					},
				},
				{
					key: "news",
					url: `/datezone/news`,
					args: {
						page: 1,
					},
					version: "1.1",
				},
			]),
		);

		return { result: response, language };
	}),
);

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	success: false,
	error: false,
	lang: null,
	data: {
		images: [],
		locationsSeo: [],
		preferencesSeo: [],
		randomVideoIndex: null,
		news: [],
	},
};

// ############################################################

// Slice
const landingSlice = createSlice({
	name: "landing",
	initialState,
	reducers: {
		setLandingData: (state, action) => {
			state.loading = false;
			state.loaded = true;
			state.success = true;
			state.error = false;
			state.lang = action.payload.lang;
			state.data = {
				images: action.payload.images,
				locationsSeo: action.payload.locationsSeo,
				preferencesSeo: action.payload.preferencesSeo,
				randomVideoIndex: action.payload.randomVideoIndex,
				news: action.payload.news,
			};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getLanding.pending, (state) => {
				state.loading = true;
			})
			.addCase(getLanding.fulfilled, (state, action) => {
				state.loading = false;
				state.loaded = true;
				state.success = true;
				state.error = false;
				state.lang = action.payload.language;

				state.data = {
					...state.data,
					images: action.payload.result?.data?.images?.response || [],
					locationsSeo:
						action.payload.result?.data?.seo?.response.location ||
						[],
					preferencesSeo:
						action.payload.result?.data.seo?.response.preferences ||
						[],
					news: action.payload.result?.data.news?.response.news
						? action.payload.result?.data.news?.response.news.slice(
								0,
								3,
							)
						: [],
				};
			})
			.addCase(getLanding.rejected, (state) => {
				state.loading = false;
				state.loaded = true;
				state.success = false;
				state.error = true;
			});
	},
});

// ############################################################

export default landingSlice.reducer;

// ** Actions
export const { setLandingData } = landingSlice.actions;

// ############################################################
